<!DOCTYPE html>
<html>
	<head>
		<meta charset="utf-8" />
		<title>FMEA :: Tech Spec</title>
		<style>
			body {
				text-align: center;
			}
		</style>
	</head>
	<body>
		<h1>FMEA Tech Spec</h1>
		<h2>Technology</h2>
		<p>Angular 13</p>
		<p>Microsoft MVC .NET Core 6 with C# syntax</p>
		<p>Entity Framework 6</p>
		<p>Microsoft SQL Server 2019</p>
		<h2>Supported Browsers</h2>
		<p>Edge</p>
		<p>Google Chrome</p>
		<p>Firefox</p>
		<h2>Domain Names</h2>
		<p>
			<a href="https://FMEA.com/">https://FMEA.com/</a><br />
			<a href="https://demo.FMEA.com/">https://demo.FMEA.com/</a>
		</p>
		<h2>Scheduled Jobs</h2>
		<p>Automated Routine - Hourly</p>
	</body>
</html>
